export { default } from './FileFrame';
export { default as FileFrame } from './FileFrame';
